import React, {useEffect, useRef, useState} from 'react'
import {useParams} from "react-router-dom";
import {get, post,deleteApi} from "../../../../Network/Axios";
import {Button, Input, KeyValue, Modal, TOAST,Switch} from "../../../../../retro";

export default function User() {
    
    let saas = window.location.href.includes('cockpit.dice.tech') || window.location.href.includes('localhost');
    const {id} = useParams();
    const ID = useRef();
    const EP = useRef();
    const CERT = useRef();
    const PW = useRef();
    const ENTITY = useRef();
    const DOMAIN = useRef();
    const [config,setConfig] = useState({})
    const [ssoConfig,setSsoConfig] = useState({});
    const [modal,setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [entityEnable,setEntityEnable] = useState(false);
    const [domainEnable,setDomainEnable] = useState(false);
    const [editingDomain, setEditingDomain] = useState(null);
    const [addIdpModal, setAddIdpModal] = useState(false);
    const [idpConfig, setIdpConfig] = useState({});

    const NAME_ID_FORMAT = useRef();
    const ENTITY_ID = useRef();
    const ACS_URL = useRef();
    const CERT_IDP = useRef();
    const DOMAIN_IDP = useRef();

    const load = id => {
        get(`/clients/saml/finance/${id}`,(e,r)=>{
            if(r){
                setConfig(r.ssoConfig)
                //setEntityConfig(r.financeMultiDomainConfig);
                setSsoConfig(r.financeMultiDomainConfig);
            }
        });
    }
    const toggle = id => {
        if(!config.enabled){
            setModal(true)
        }else{
            post(`/clients/saml/finance/${id}/toggle`,{},(e,r)=>{
                if(r){
                    load(id)
                }
            });
        }
    }

  const getIDP = () => {
    get(`/clients/saml/idp/${id}`,(e,r)=>{
      if(r){
        setIdpConfig(r)
      }
    });
  }

    const toggleIdp = id => {
        if (!idpConfig?.idpSpConfigData?.enabled) {
            setAddIdpModal(true)
        } else {
            deleteApi(`/clients/saml/idp/removeSp/${id}`, (e, r) => {
                if (r) {
                    getIDP(id)
                }
            });
        }
    }


    useEffect(()=>{
        load(id)
        if(saas) getIDP(id)
    },[id])


    let mapItemSso = (item,index) => {
        let mItem = ssoConfig[item]
        return(
            <div key={index} className='mt4 border-bottom flex horizontally'>
                <div className='flex-1'> 
                     <p className="text text-light">
                        Domain {item}
                     </p>
                    <p className="">
                        {config.endPoint}
                    </p>
                    <KeyValue title="Id" value={mItem.id} margin="mt1"/>
                    <KeyValue title="Cert" value={mItem.cert}/>
                    <div className="flex">
                        <p style={{width:100,textAlign:'left'}} className="btn-link-danger btn mg0 pd0 mb2 mr2" onClick={()=>{
                            deleteApi(`clients/saml/finance/removeSso/${id}?domain=${item}`,(e,r)=>{
                                load(id);
                                TOAST.success("Domain Removed Successfully")
                            })
                        }}>
                            Delete
                        </p>
                        <p style={{width:100,textAlign:'left'}} className="btn-link btn mg0 pd0 mb2" onClick={()=>{
                            setEditingDomain(item);
                            // Set values after a small delay to ensure refs are initialized
                            setTimeout(() => {
                                if (DOMAIN.current) DOMAIN.current.value = item;
                                if (ID.current) ID.current.value = mItem.id;
                                if (EP.current) EP.current.value = mItem.endPoint;
                                if (CERT.current) CERT.current.value = mItem.cert;
                                if (PW.current) PW.current.value = mItem.password;
                            }, 0);
                            setEditModal(true);
                        }}>
                            Edit
                        </p>
                    </div>
                </div>
                <div>
                <Switch
                    onChange={() => {
                        post(`/clients/saml/finance/${id}/toggle`,{domain:item},(e,r)=>{
                            if(r){
                                load(id)
                            }
                        });
                    }}
                    state={mItem.enabled}
                />
                </div>
               
            </div>
        )
    }

    let mapItemIdp = (item,index) => {
        let mItem = idpConfig.multiDomainIdpSpConfig[item]
        return(
            <div key={index} className='mt4 border-bottom flex horizontally'>
                <div className='flex-1'> 
                     <p className="text text-light">
                        Domain {item}
                     </p>
                    <KeyValue title="Name Id Format" value={mItem.nameIdFormat} margin="mt1"/>
                    <KeyValue title="Entity ID" value={mItem.entityId}/>
                    <KeyValue title="ACS URL" value={mItem.acsUrl}/>
                    <KeyValue title="Certificate" value={mItem.cert}/>
                    <div className="flex">
                        <p style={{width:100,textAlign:'left'}} className="btn-link-danger btn mg0 pd0 mb2 mr2" onClick={()=>{
                            deleteApi(`/clients/saml/idp/removeSp/${id}?domain=${item}`,(e,r)=>{
                                getIDP();
                                TOAST.success("Domain Removed Successfully")
                            })
                        }}>
                            Delete
                        </p>
                    </div>
                </div>
                <div>
                </div>
               
            </div>
        )
    }

    const handleModalSubmit = () => {
        let mId = ID.current.value;
        let ep = EP.current.value;
        let crt = CERT.current.value;
        let pw = PW.current.value;
        let data = {
            id: mId,
            ep,
            crt,
            pw
        }
        if(saas && entityEnable) {
            data.entity = ENTITY.current.value;
        }
        if(saas && domainEnable) {
            data.domain = DOMAIN.current.value;
        }

        post(`/clients/saml/finance/${id}`, data, (e,r) => {
            if(r){
                TOAST.success("SAML configuration successful!!")
                setModal(false)
                load(id)
            }
        })
    }

    const handleEditModalSubmit = () => {
        let mId = ID.current.value;
        let ep = EP.current.value;
        let crt = CERT.current.value;
        let pw = PW.current.value;
        let data = {
            id: mId,
            ep,
            crt,
            pw,
            domain: editingDomain
        }

        post(`/clients/saml/finance/${id}`, data, (e,r) => {
            if(r){
                TOAST.success("SAML configuration updated successfully!")
                setEditIdpModal(false)
                setEditingDomain(null)
                getIDP(id)
            }
        })
    }


    const handleAddIdpModalSubmit = () => {
        let nameIdFormat = NAME_ID_FORMAT.current.value;
        let entityId = ENTITY_ID.current.value;
        let acsUrl = ACS_URL.current.value;
        let certIdp = CERT_IDP.current.value;
        let domainIdp = DOMAIN_IDP.current.value;
        
        if (!nameIdFormat) {
            TOAST.error("Please fill all the fields")
            return
        }
        if (!entityId) {
            TOAST.error("Please fill all the fields")
            return
        }
        if (!acsUrl) {
            TOAST.error("Please fill all the fields")
            return
        }
       
        let data = {
            nameIdFormat,
            entityId,
            acsUrl,
            cert:certIdp,
            domain:domainIdp
        }

        post(`/clients/saml/idp/${id}`, data, (e, r) => {
            if (r) {
                setAddIdpModal(false)
                TOAST.success("IDP configuration successful!!")
                getIDP(id)
            } else {
                TOAST.handleError(e)
            }
        })
    }


    return(
        <>
            {
                modal && <Modal title="Sso Config" description="Sso configuration" onClose={()=>{setModal(false)}}>
                    {
                    saas &&
                    <>
                       <div className='flex'>
                            <div className='flex-1'>
                                Enable Entity
                            </div>
                            <Switch
                                onChange={() => {
                                    setEntityEnable(!entityEnable);
                                    setDomainEnable(false);
                                }}
                                state={entityEnable}
                            />
                       </div>
                        <p className="mt1 mb1 font-bold">OR</p>
                       <div className='flex'>
                            <div className='flex-1'>
                                Enable Domain
                            </div>
                            <Switch
                                onChange={() => {
                                    setDomainEnable(!domainEnable);
                                    setEntityEnable(false);
                                }}
                                state={domainEnable}
                            />
                       </div>
                       {
                        entityEnable && <Input  allowSpecialCharacters={true} type="text" ref={ENTITY} placeholder="Enter Entity (optional)" label="Enter Entity(optional)"/>
                       }
                       {
                        domainEnable && 
                        <Input allowSpecialCharacters={true} type="text" ref={DOMAIN} placeholder="Enter Domain (optional)" label="Enter Domain(optional)"/>

                       }
                    </>
                    }
                    <Input allowSpecialCharacters={true} type="text" ref={ID} placeholder="Enter Id" label="Name Id"/>
                    <Input allowSpecialCharacters={true} type="text" ref={EP} placeholder="Enter Endpoint" label="Endpoint"/>
                    <Input allowSpecialCharacters={true} type="text" ref={CERT} placeholder="Enter Cert" label="Certificate"/>
                    <Input allowSpecialCharacters={true} type="text" ref={PW} placeholder="Enter Password" label="Password"/>
                    <Button margin="mt4" onClick={handleModalSubmit} className="btn btn-black">
                        + Add Sso
                    </Button>
                </Modal>
            }

            {
                editModal && <Modal title="Edit Sso Config" description="Edit Sso configuration" onClose={()=>{
                    setEditModal(false)
                    setEditingDomain(null)
                }}>
                    <Input allowSpecialCharacters={true} type="text" ref={DOMAIN} placeholder="Enter Domain" label="Domain" disabled/>
                    <Input allowSpecialCharacters={true} type="text" ref={ID} placeholder="Enter Id" label="Name Id"/>
                    <Input allowSpecialCharacters={true} type="text" ref={EP} placeholder="Enter Endpoint" label="Endpoint"/>
                    <Input allowSpecialCharacters={true} type="text" ref={CERT} placeholder="Enter Cert" label="Certificate"/>
                    <Input allowSpecialCharacters={true} type="text" ref={PW} placeholder="Enter Password" label="Password"/>
                    <Button margin="mt4" onClick={handleEditModalSubmit} className="btn btn-black">
                        Update Sso
                    </Button>
                </Modal>
            }
            {
                addIdpModal && <Modal title="Add IDP" description="Add IDP configuration" onClose={()=>{
                    setAddIdpModal(false)
                    setEditingDomain(null)
                }}>
                    <Input allowSpecialCharacters={true} type="text" ref={NAME_ID_FORMAT} placeholder="Name ID Formate" label="Name Id Format"/>
                    <Input allowSpecialCharacters={true} type="text" ref={ENTITY_ID} placeholder="Entity ID" label="Entity ID"/>
                    <Input allowSpecialCharacters={true} type="text" ref={ACS_URL} placeholder="Enter ACS URL" label="ACS URL"/>
                    <Input allowSpecialCharacters={true} type="text" ref={CERT_IDP} placeholder="Enter Cert" label="Certificate (optional)"/>
                    <Input allowSpecialCharacters={true} type="text" ref={DOMAIN_IDP} placeholder="Enter domain" label="Domain (optional)"/>
                    <Button margin="mt4" onClick={handleAddIdpModalSubmit} className="btn btn-black">
                        Add IDP
                    </Button>
                </Modal>
            }

            <div className="border rounded-md pd4 mt4">
                <h2 className="fw-bold">
                   Finance Authentication Settings
                </h2>
                <p>
                    Enable authentication settings appears below.
                </p>
                {
                    config.enabled&&<div className="mt4">
                        <p className="text text-light">
                            Endpoint:
                        </p>
                        <p className="">
                            {config.endPoint}
                        </p>
                        <KeyValue title="Id" value={config.id} margin="mt1"/>
                        <KeyValue title="Cert" value={config.cert}/>
                    </div>
                }
                {
                    saas && ssoConfig &&
                    Object.keys(ssoConfig).map(mapItemSso)
                }
                
                <div className="flex">
                    <Button onClick={toggle.bind(this,id)} className="btn btn-black" margin="mt4 mr2" style={{width:300}}>
                        {
                            config.enabled ? "- Disable Authentication":"+ Enable Authentication"
                        }
                    </Button>
                    <Button onClick={() => {
                        setModal(true);
                    }} className="btn btn-black" margin="mt4" style={{width:300}}>
                        + Add Domain Authentication
                    </Button>
                </div>
            </div>
            {saas && (
                <>
                   <div className="border rounded-md pd4 mt4">
                <h2 className="fw-bold">
                   IDP Settings
                </h2>
                <p>
                    IDP settings appears below.
                </p>
                {
                    idpConfig?.idpSpConfigData?.enabled && <div className="mt4">
                        <KeyValue title="Name Id Format" value={idpConfig?.idpSpConfigData?.nameIdFormat} margin="mt1"/>
                        <KeyValue title="Entity ID" value={idpConfig?.idpSpConfigData?.entityId} margin="mt1"/>
                        <KeyValue title="ACS URL" value={idpConfig?.idpSpConfigData?.acsUrl} margin="mt1"/>
                        <KeyValue title="Certificate" value={idpConfig?.idpSpConfigData?.certIdp} margin="mt1"/>
                        <KeyValue title="Domain" value={idpConfig?.idpSpConfigData?.domainIdp} margin="mt1"/>
                        <div className="flex">
                        <p style={{width:100,textAlign:'left'}} className="btn-link-danger btn mg0 pd0 mb2 mr2" onClick={()=>{
                           deleteApi(`/clients/saml/idp/removeSp/${id}`, (e, r) => {
                            if (r) {
                                getIDP(id)
                            }
                        });
                        }}>
                            Delete
                        </p>
                    </div>
                    </div>
                }
                {/* Map MultiDomain */}
                {
                    idpConfig?.multiDomainIdpSpConfig &&
                    Object.keys(idpConfig.multiDomainIdpSpConfig).map(mapItemIdp)
                }
                <div className="flex">
                    <Button onClick={toggleIdp.bind(this,id)} className="btn btn-black" margin="mt4 mr2" style={{width:300}}>
                        {
                            idpConfig?.idpSpConfigData?.enabled ? "- Disable Authentication":"+ Enable Authentication"
                        }
                    </Button>
                </div>
            </div>
                </>
            )}
        </>
    )
}
